export default __webpack_public_path__ + "static/media/button_plus.c3efe1c9.png";